import { Input } from '@/components/ui/input';
import { ChangeEvent } from 'react';

interface PhoneInputProps {
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  showLabel?: boolean;
  label?: string;
  placeholder?: string;
}

function formatPhoneNumber(value: string): string {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');

  // Limit to 10 digits
  const limited = digits.slice(0, 10);

  // Format as (XXX) XXX-XXXX
  if (limited.length === 0) {
    return '';
  } else if (limited.length <= 3) {
    return `(${limited}`;
  } else if (limited.length <= 6) {
    return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  } else {
    return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
  }
}

function getDigitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

export function PhoneInput({
  value = '',
  onChange,
  disabled = false,
  required = false,
  showLabel = true,
  label = 'Phone Number',
  placeholder = '(555) 555-5555',
}: PhoneInputProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const formatted = formatPhoneNumber(inputValue);
    onChange(formatted);
  };

  return (
    <div>
      {showLabel && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label} {required && <span className="text-red-600">*</span>}
        </label>
      )}
      <Input
        type="tel"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={14} // (XXX) XXX-XXXX = 14 characters
      />
    </div>
  );
}

// Export utility function to get raw digits from formatted phone
export function getPhoneDigits(formattedPhone: string): string {
  return getDigitsOnly(formattedPhone);
}
